// @import dependencies
import React, { CSSProperties, useEffect, useState} from 'react'
// @end dependencies

// @import components
import ButtonComponent, { ButtonComponentProps } from 'app_components/commons/Button/ButtonComponent';
// @end components

// @import types
import { TypePermissionsForum } from 'app_types/admin/forum/forumTypes';
import { CombinedReducers } from 'app_events/index';
// @end types

// @import services
// @end services

// @import hooks
import { useDispatch, useSelector } from 'react-redux';
// @end hooks

// @import actions
// @end actions

// @import utils
// @end utils

// @import assets
// @end assets

// @import styles
import './ButtonAddShoppingCar.scss'
import { shoppingCarChange } from 'app_events/app/actions';
import { IShoppingCarItem } from 'app_types/shoppingCart/shoppingCarTypes';
import { IActionsCart } from 'app_events/app/types';
// @end styles
import {routingService} from 'app_services/routingService'

interface IButtonAddShoppingCarProps {
  className?: string
  style?: CSSProperties
  id?: string
  classNameButton?: string
  styleButton?: CSSProperties
  idButton?: string
  children?: any
  disabled?: boolean
  variant?: ButtonComponentProps['variant'];
  loading?: boolean
  iconColor?: string
  permissions?: Permission[]
  type?: ButtonComponentProps['type'];
  loginText?: string
  showButtonOnDenegate?: boolean
  onClick?: ()=>void
  onLoginSuccess?: () => void
  itemToBuy: IShoppingCarItem
  buyNow?: boolean
}

interface Permission{
  module: 'module:forums',
  permissions: TypePermissionsForum[]
}

const ButtonAddShoppingCar: React.FC<IButtonAddShoppingCarProps> = ({itemToBuy, buyNow, ...props}) => {

  const [itemAdded, setItemAdded] = useState<boolean>(false);
  const dispatch = useDispatch()
  const {data: shoppingCarItems}: {action: IActionsCart, data: IShoppingCarItem[]} = useSelector((store: CombinedReducers) => store?.app?.shoppingCart ?? {action: 'none', data: []});

  const handleClickButton = () => {
    if (!itemAdded) {
      itemToBuy.dateOfAddition = new Date().getTime();
      dispatch(shoppingCarChange(
        {
          action: 'add',
          data: [
            ...shoppingCarItems,
            itemToBuy
          ]
        }
      ))
    }
    if (buyNow) {
      window.location.href = routingService.getPublicPath('/shopping-cart')
    }
  }

  const isDisabled = () => {
    if (buyNow) return false;
    const find = shoppingCarItems.findIndex((i) => i.identifier === itemToBuy.identifier || i.programCode === itemToBuy.programCode)
    if (find !== -1) return true
    return false
  }

  const isAdded = () => {
    const find = shoppingCarItems.findIndex((i) => i.identifier === itemToBuy.identifier || i.programCode === itemToBuy.programCode)
    if (find !== -1) return true
    return false
  }

  useEffect(() => {
    setItemAdded(isAdded());
  }, [shoppingCarItems, itemToBuy]);

  return(
    <div
      className={`button_add_shopping_car-layout ${props.className ? props.className : ''}`}
      style={props.style}
      id={props.id}
    >
      <ButtonComponent
        className={props.classNameButton}
        style={props.styleButton}
        id={props.idButton}
        variant={props.variant}
        type={props.type}
        iconColor={props.iconColor}
        loading={props.loading}
        disabled={isDisabled()}
        onClick={handleClickButton}
      >
        {isDisabled() ? 'Agregado' : props.children}
      </ButtonComponent>
    </div>
  );
}

export default ButtonAddShoppingCar;
